export enum AutomationEditorView {
  Compose = 'compose',
  Settings = 'settings',
}
